import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/ad";
// 广告
const adApi = {
  page(params) {
    return request({
      url: `${baseUrl}/page`,
      method: "GET",
      params
    });
  }
};
export default adApi;
